import React from 'react'
import { Box, Grid, makeStyles, Typography } from '@material-ui/core'
import { Home } from 'react-feather'
import { useTranslation } from 'react-i18next'
import { BuildingFragment } from '../../../generated/graphql'
import { formatArea } from '../../../util/formatters'
import { Section } from '../../common/Section'
import { isValidPart } from '../../../hour-series-collection/hour-series-collection-utility'

const useStyles = makeStyles((theme) => ({
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: theme.spacing(1),
    width: 50,
    height: 50,
    backgroundColor: theme.palette.grey['200'],
    borderRadius: theme.shape.borderRadius,
  },
  secondaryText: {
    color: theme.palette.grey['500'], // Should be #a2a2a2
  },
}))

type Props = {
  building: BuildingFragment
}

export function BuildingParts({ building }: Props): React.ReactElement {
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <Section title={t('building.tabs.basicInfo.parts')}>
      <Grid container spacing={4}>
        {building.parts.filter(isValidPart).map((part) => (
          <Grid item sm={4} key={part.id}>
            <Box display="flex">
              <Box className={classes.iconContainer}>
                <Home size={35} />
              </Box>
              <Box>
                <Typography variant="subtitle1">{part.name}</Typography>
                <Typography variant="body2" className={classes.secondaryText}>
                  {formatArea(part.partArea)}
                </Typography>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Section>
  )
}
